<div class="field-validation-dialog">
  <div class="dialog-icon-section">
    <div class="icon-circle" [ngClass]="{'success': data.isSuccess, 'error': !data.isSuccess}">
      <mat-icon *ngIf="data.isSuccess" class="check-icon">check</mat-icon>
      <mat-icon *ngIf="!data.isSuccess" class="error-icon">close</mat-icon>
    </div>
  </div>

  <div class="dialog-content">
    <h2 class="dialog-title" [ngClass]="{'success-text': data.isSuccess, 'error-text': !data.isSuccess}">
      {{ data.title }}
    </h2>

    <p class="dialog-message">
      {{ data.message }}
    </p>
  </div>

  <div class="dialog-actions">
    <button mat-raised-button
            color="primary"
            class="ok-button"
            (click)="onOkClick()">
      OK
    </button>
  </div>
</div>